export default {
  payWelfareText: 'Beneficios de recarga',
  blackFridayDiscount: 'Descuento limitado de Black Friday',
  shareGift: 'Compartir regalo',
  vipWeeklyWelfare: 'Descuento semanal VIP',
  exchangeCoupon: 'Cupón',
  firstPayOff: 'Hasta un 15% de descuento en la 1.ª compra',
  blackFridayEvent: 'Evento de Black Friday',
  limitedTimeOff: '10% de descuento por tiempo limitado',
  claimCoupon: 'Reclamar ahora',
  blackFridayTimedCoupon: 'Cupón limitado de Black Friday',
  timeLeft: 'Tiempo restante: ',
  claimTimeCoupon: '¡Reclamar ya el cupón del 10% de descuento!',
  points: 'Puntos: ${point}',
  costPointTip: 'Canjear puntos por cupones',
  maxPointTip: 'Cada cuenta puede usar hasta 500 puntos.',
  discountOff: '10% de descuento',
  highestDiscount: 'Hasta ${discount} de descuento',
  needPoint: 'Se necesitan ${point} ptos',
  changeCurrency: 'Cambiar moneda',
  claim: 'Reclamar',
  claimSucc: 'Reclamado',
  claimFail: 'Fallido',
  pointNotEnough: 'Puntos insuficientes',
  afterClaimPoint: 'Puntos restantes: ${point}',
  footTips1: 'Solo se puede usar 1 cupón por orden.',
  footTips2:
    'El cupón no se puede usar para comprar monedas o tokens del juego.',
  footTips3:
    ' Nos reservamos el derecho a dar una interpretación final de este evento.',
  ruleTitleText: 'Reglas del evento',
  ruleTime:
    'Duración del evento: Del 24 de nov. 2023, 00:00, al 26 de nov. 2023, 23:59 (UTC)',
  bfRuleText1:
    '1. Se te acreditarán 400 puntos en tu cuenta cuando te conectes a la página oficial de recargas por primera vez durante el evento. Podrás canjear hasta 500 puntos por cupones.',
  bfRuleText2:
    '2. Podrás canjear los puntos del Black Friday por cupones durante el evento.',
  bfRuleText3:
    '3. Solo se puede usar 1 cupón por orden. No se pueden usar cupones para comprar monedas ni tokens del juego.',
  bfRuleText4:
    '4. Para las transacciones, solo aceptamos las siguientes monedas:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. No se pueden cambiar la moneda una vez realizada la transacción. Los puntos canjeados no se pueden reembolsar.',
  bfRuleText6: '6. Los cupones del Black Friday tendrán validez solo por 7 días.',
  bfRuleText7:
    '7. Nos reservamos el derecho a dar una interpretación final de este evento.',
  thanksTip:
    'Gracias por participar. Únete a nuestra comunidad oficial para obtener más información sobre el evento.',
  exchangePoints: 'Intercambiar',
  exchangeCode: 'Ingresa el código de cambio.',
  enterExchangeCode: 'Ingresa el código de cambio.',
  exchangeText: 'Intercambiar',
  confirmGet: 'Confirmar',
  couponUsedWay:
    'El cupón solo se puede usar con ciertas divisas. Confirma primero la moneda a usar.',
  confirmText: 'Confirmar',
  exchangeSucc: 'Canjeado',
  aboutCoins: 'Sobre las monedas/tokens del juego',
  aboutCoinsText:
    'Podrás canjear las monedas y tokens del juego por todos los paquetes y privilegios, pero no por la propia moneda/token del juego.',
  known: 'OK',
  codeText: 'Código',
  codeInvalid: '¡Código no válido!',
  hasExchanged: 'No puedes reclamar más códigos.',
  hideText: 'Ocultar',
  //黑五的报错码
  'bf-20001': 'No se ha iniciado sesión',
  'bf-20002': 'Error de parámetro. Intenta ingresar de nuevo al evento.',
  'bf-20003': 'Puntos insuficientes',
  'bf-20004':
    '¡Falló! Vuelve a intentarlo más tarde o ponte en contacto con el servicio de atención al cliente.',
  'bf-20005': 'Reclamado',
  'bf-20015': 'El evento no está disponible actualmente.',
  'bf-20016': 'El evento ya terminó.',
  bfShareText: '¡Reclamar ya el cupón del 10% de descuento!',
  rightsCenterBtn: 'Centro de miembros premium',
  payBtn: 'RECARGAS',
  hasEqualRewardMuglo: '¡Un BONUS de hasta 1800 diamantes del sitio web oficial de recargas!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Gloria extraordinaria (permanente)',
  '-': '-'
};
